import { createApiRef } from '@backstage/core-plugin-api';

/** Dados do usuario vindos do Notion */
export interface NotionUser {
  nome: string;
  email: string;
  ativo: boolean;
  papel: string;
  grupoVpn: string;
  githubUsername: string;
  gruposAD: string[];
  criadoEm: string;
  editadoEm: string;
}

/** Time do GitHub */
export interface GithubTeam {
  name: string;
  slug: string;
  role: string;
  description: string;
}

/** Grupo do Google Workspace */
export interface GoogleGroup {
  name: string;
  email: string;
  role: string;
  description?: string;
}

export type SourceStatus = 'ok' | 'error' | 'not_found';

/** Resposta unificada da API /me */
export interface AccessData {
  user: NotionUser;
  github: {
    status: SourceStatus;
    teams: GithubTeam[];
    error?: string;
  };
  googleGroups: {
    status: SourceStatus;
    groups: GoogleGroup[];
    error?: string;
  };
  sources: {
    notion: SourceStatus;
    github: SourceStatus;
    googleAdmin: SourceStatus;
  };
}

/** Item do Inventory Management do Notion */
export interface InventoryItem {
  pageId: string;
  nome: string;
}

/** Item da database Clientes do Notion */
export interface ClientItem {
  pageId: string;
  nome: string;
}

/** Item da database Iniciativas do Notion */
export interface InitiativeItem {
  pageId: string;
  nome: string;
}

/** Payload para criacao de solicitacao de acesso */
export interface AccessRequestPayload {
  sistemaPageId: string;
  sistemaNome: string;
  ambiente: 'Prod' | 'Homolog' | 'Develop';
  iniciativaPageId: string;
  iniciativaNome: string;
  justificativa: string;
}

/** Resultado da criacao de solicitacao */
export interface AccessRequestResult {
  pageId: string;
  titulo: string;
  url: string;
}

/** Solicitacao de acesso retornada pela API */
export interface AccessRequest {
  pageId: string;
  nome: string;
  sistema: string;
  ambiente: string;
  iniciativa: string;
  cliente: string;
  justificativa: string;
  status: string;
  criadoEm: string;
}

/** Comentario de uma pagina do Notion */
export interface RequestComment {
  id: string;
  authorName: string;
  authorAvatarUrl: string;
  text: string;
  createdAt: string;
  isBot: boolean;
}

export interface FinayaAccessApi {
  getMyAccess(): Promise<AccessData>;
  getInventory(): Promise<InventoryItem[]>;
  getClients(): Promise<ClientItem[]>;
  getInitiatives(clientePageId: string): Promise<InitiativeItem[]>;
  createAccessRequest(payload: AccessRequestPayload): Promise<AccessRequestResult>;
  getMyRequests(): Promise<AccessRequest[]>;
  getRequestComments(pageId: string): Promise<RequestComment[]>;
  addRequestComment(pageId: string, text: string): Promise<RequestComment>;
}

export const finayaAccessApiRef = createApiRef<FinayaAccessApi>({
  id: 'plugin.finaya-access.api',
});
